// extracted by mini-css-extract-plugin
export default {"root":"Button_root__N9wx-","nopad":"Button_nopad__6tcoM","italic":"Button_italic__WJ4xm","wide":"Button_wide__4WTGu","outline":"Button_outline__IVuqW"};